import { render } from "./PolicyInfo.vue?vue&type=template&id=5b2df8d9&scoped=true"
import script from "./PolicyInfo.vue?vue&type=script&lang=js"
export * from "./PolicyInfo.vue?vue&type=script&lang=js"

import "./PolicyInfo.vue?vue&type=style&index=0&id=5b2df8d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2df8d9"]])

export default __exports__